export enum PupilsConstants {
  NOT_IMPLEMENTED = 'pupils/NOT_IMPLEMENTED',
  SET_PUPILSIZEL = 'pupils/SET_PUPILSIZEL',
  SET_PUPILRXL = 'pupils/SET_PUPILRXL',
  SET_PUPILSIZER = 'pupils/SET_PUPILSIZER',
  SET_PUPILRXR = 'pupils/SET_PUPILRXR',
  SET_HEADREACTIVE = 'pupils/SET_HEADREACTIVE',

  SAVE_PUPILS = 'pupils/SAVE_PUPILS',
  SET_RESPONSE = 'pupils/SET_RESPONSE',
  SET_PUPILS = 'pupils/SET_PUPILS',
  RESET_PUPILS_STATE = 'pupils/RESET_PUPILS_STATE',
}
